@if (notifications(); as notifications) {
  <div class="notification-container">
    @if (notifications.length >= 4) {
      <div class="btn-wrapper">
        <button mat-button (click)="clearAllNotifications()" [innerHTML]="'common.closeAll' | translate"></button>
      </div>
    }
    <div class="notifications-wrapper">
      @for (notification of notifications; track notification; let i = $index) {
        <div
          (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()"
          class="notification-popup"
          [ngClass]="{
            info: notification.type === ENotificationMessage.INFO,
            success: notification.type === ENotificationMessage.SUCCESS,
            error: notification.type === ENotificationMessage.ERROR,
          }"
        >
          <div
            class="notification-popup-header"
            [ngClass]="{
              info: notification.type === ENotificationMessage.INFO,
              success: notification.type === ENotificationMessage.SUCCESS,
              error: notification.type === ENotificationMessage.ERROR,
            }"
          >
            {{ notification.i18nTitle | translate }}
            <button mat-icon-button class="notification-popup-close" (click)="closeNotification(i)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="notification-popup-body">
            {{ notification.i18nMessage | translate }}
          </div>
        </div>
      }
    </div>
  </div>
}
